import { createHttpClient } from '../utils/httpUtils';
import { base } from './base';

const baseURL = base.apiAnalytics;

class ScheduleImpactRequestService {
  constructor() {
    this.http = createHttpClient({ baseURL });
  }

  async getDataToDraft(projectId, sectorId) {
    const res = await this.http.get(
      `scheduleimpactrequests/project/${projectId}/schedule/${sectorId}/draft`
    );
    return res.data;
  }

  async sendScheduleImpactRequest(projectId, sectorId, data) {
    const res = await this.http.post(
      `scheduleimpactrequests/project/${projectId}/schedule/${sectorId}/pending`,
      data
    );
    return res.data;
  }

  async getPendingRequestDetails(projectId, sectorId, requestId) {
    const res = await this.http.get(
      `scheduleimpactrequests/project/${projectId}/schedule/${sectorId}/pending/${requestId}`
    );
    return res.data;
  }

  async patchStatus(projectId, sectorId, requestId, data) {
    const res = await this.http.patch(
      `scheduleimpactrequests/project/${projectId}/schedule/${sectorId}/pending/${requestId}`,
      data
    );
    return res.data;
  }

  async getRequestDetails(projectId, sectorId, requestId) {
    const res = await this.http.get(
      `scheduleimpactrequests/project/${projectId}/schedule/${sectorId}/${requestId}`
    );
    return res.data;
  }
}

export const scheduleImpactRequestService = new ScheduleImpactRequestService();
